export default "__VITE_ASSET__VK3rvCQg__"